import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';


const ViewProjectMeter = ({meterId}) => {
    const [meterData, setMeterData] = useState(null);

    const fetchProjectMeter = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/project_meter/${Id}`)
            .then(response => {
                setMeterData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setMeterData([]); 
            });
    }

    useEffect(() => {
        if (meterId) {
            fetchProjectMeter(meterId);
        }
    },[meterId]);

    if (!meterId || !meterData) {
        return null;
    }

    return (
        <div id={`view_project_meter_${meterId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">View Project Meter</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel</label>
                                        <input className="form-control" type="text" value={meterData.channel} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Client</label>
                                        <input className="form-control" type="text" value={meterData.client} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project</label>
                                        <input className="form-control" type="text" value={meterData.project} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Meter Type</label>
                                        <div className="radio">
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="radio" checked={meterData.meter_type === '1'} /> Hourly
                                            </label>
                                            <label className="col-form-label" style={{marginRight:'15px'}}>
                                                <input type="radio" checked={meterData.meter_type === '0'} /> Fixed
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Meter</label>
                                        <input className="form-control" type="text" value={meterData.meter} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">{meterData.meter_type === '1' ? 'Hourly' : 'Fixed'} Price
                                        (<i className="fa-solid fa-dollar-sign"></i>)
                                        </label>
                                        <input className="form-control" type="text" value={meterData.price} disabled/>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Description</label>
                                        <textarea className="form-control" type="text" value={meterData.description || ''} disabled/>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewProjectMeter
